import type { ReactNode } from 'react';
import type { To } from 'react-router';

import { Link } from '@sorare/routing';
import { css } from '@sorare/css';

import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { laptopAndAbove } from '#src/style/mediaQuery.ts';

const root = css`
  display: flex;
  align-items: center;
  gap: var(--double-unit);

  background-color: var(--c-surface-primary);
  border-radius: var(--intermediate-unit);
  padding: var(--triple-unit);

  &:hover {
    background-color: var(--c-surface-secondary);
  }
  transition: background-color 100ms ease-in-out;

  @media ${laptopAndAbove} {
    width: 340px;
  }
`;
const iconWrapper = css`
  width: min-content;
`;
const fullWidthVertical = css`
  flex: 1;
`;

type Props = {
  to: To;
  icon: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  onClick?: () => void;
};
export const SportLink = ({ to, icon, title, subtitle, onClick }: Props) => {
  return (
    <Link className={root} to={to} onClick={onClick}>
      <div className={iconWrapper}>{icon}</div>
      <Vertical className={fullWidthVertical} gap={0}>
        {title}
        {subtitle}
      </Vertical>
    </Link>
  );
};
